import React, {Component} from "react";
import {UiActions} from "state/actions/UiActions";
import {connect} from "react-redux";
import classname from "classnames";
import Styles from "../../views/pages/PerfilDeBeleza.module.scss";

export class BeautyProfileQuestion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      question: this.props.question,
      isBald: false
    };

    this.updateOdersCheckboxes = this.updateOdersCheckboxes.bind(this);
    this.checkIsNoneOfThePrevious = this.checkIsNoneOfThePrevious.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.question.id !== this.props.question.id) {
      this.setState({
        question: this.props.question
      });
    }
  }

  updateValues(index) {

    let {question} = this.state;
    let option = question.options[index];

    return (event) => {
      let checked = event.currentTarget.checked;
      question = this.updateOdersCheckboxes(checked, option.isSingleOption, 'name', option);
    }
  }

  checkIsNoneOfThePrevious(name){
    let {question} = this.state;
    let regex = '(Nenhum|Outro|Não)';

    if(name.match(regex)){
      question.options.forEach((item) => {
        if(item.name != name){
          item.checked = false;
        }
        else item.checked = true;
      });
    }
    else{
      question.options.forEach((item) => {
        if(item.name.match(regex)){
          item.checked = false;
        }
      });
    }
  }

  updateOdersCheckboxes(checked, isSingleOption, attr, option) {
    let {question} = this.state;
    var moveFoward = false;

    question.options.forEach((item) => {
      if (item[attr] === option[attr]) {
        if (checked) {
          item.checked = true;
          this.checkIsNoneOfThePrevious(item.name);
        } else {
          item.checked = false;
        }
      } else {
         if (question.type === 1) {
           item.checked = false;
         }
      }
      // if (item[attr] !== option[attr] && item.isSingleOption && item.checked) {
      //   item.checked = false;
      // }

    });

    this.setState({question});

    // if (checked && question.type == 1) {
    //   moveFoward = true;
    // }

    this.props.callback(question, moveFoward);
  }

  renderOptions() {
    // Renderiza inputs p/ cada questão
    let style = {'backgroundImage': ''};

    return this.state.question.options.map((item, key) => {

      let _cls = [Styles['checked-option']];
      if (item.checked) _cls.push(Styles["checked"]);

      let imageUrl = item.imageUrl.replace(/\.png/, ".jpg");
      
      return (
        <label style={style} key={key} className={classname(_cls)}>
          <input type={"checkbox"}
                 onChange={this.updateValues(key)}
                 checked={item.checked}
                 style={{display: 'none'}}
          />
          <span><img src={'/beautyprofile' + imageUrl}/></span>
        </label>
      );
    });
  }

  render() {
    const {props, state} = this;

    return (
      <div>
        <h3>{this.state.question.question}</h3>
        <div className={Styles["option-container"]}>
          {this.renderOptions()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
}

BeautyProfileQuestion = connect(mapStateToProps, mapDispatchToProps)(BeautyProfileQuestion);